const findDialog = (button) => {
  const selector = button?.dataset.cartUpsellOpen;
  if (!selector) return null;
  try {
    return document.querySelector(selector);
  } catch {
    return null;
  }
};

document.addEventListener('click', (event) => {
  const continueButton = event.target.closest('[data-cart-upsell-continue]');
  if (continueButton) return;

  const checkoutButton = event.target.closest('[data-cart-upsell-open]');
  if (!checkoutButton || checkoutButton.disabled) return;

  const dialog = findDialog(checkoutButton);
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;

  event.preventDefault();
  dialog.showModal();
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
  const submitter = event.submitter;
  if (!submitter || submitter.name !== 'checkout' || submitter.hasAttribute('data-cart-upsell-continue')) return;

  const dialog = findDialog(submitter);
  if (!dialog || typeof dialog.showModal !== 'function') return;

  event.preventDefault();
  dialog.showModal();
});

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-cart-upsell-close]');
  if (closeButton) {
    closeButton.closest('[data-cart-upsell-dialog]')?.close();
    return;
  }

  const addButton = event.target.closest('[data-cart-upsell-add]');
  if (!addButton || addButton.disabled) return;

  const dialog = addButton.closest('[data-cart-upsell-dialog]');
  const variantId = Number(addButton.dataset.variantId);
  if (!dialog || !Number.isSafeInteger(variantId)) return;

  const product = addButton.closest('.cart-upsell-dialog__product');
  const quantityInput = product?.querySelector('[data-cart-upsell-quantity]');
  const quantity = Number.parseInt(quantityInput?.value ?? '1', 10);
  const statusElement = dialog.querySelector('[data-cart-upsell-status]');
  if (!Number.isSafeInteger(quantity) || quantity < 1) {
    if (statusElement) statusElement.textContent = 'Choisissez une quantité d’au moins 1.';
    quantityInput?.focus();
    return;
  }
  const maxQuantity = Number.parseInt(quantityInput?.max ?? '', 10);
  if (Number.isSafeInteger(maxQuantity) && maxQuantity > 0 && quantity > maxQuantity) {
    if (statusElement) statusElement.textContent = `Il reste ${maxQuantity} exemplaire(s) disponible(s).`;
    quantityInput.value = String(maxQuantity);
    quantityInput.focus();
    return;
  }

  addButton.disabled = true;
  const continueButton = dialog.querySelector('[data-cart-upsell-continue]');
  if (continueButton) continueButton.disabled = true;
  const originalText = addButton.textContent;
  addButton.textContent = 'Ajout…';

  fetch(dialog.dataset.cartAddUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Impossible d’ajouter cet article au panier.');
      dialog.dataset.cartChanged = 'true';
      addButton.textContent = 'Ajouté';
      const status = dialog.querySelector('[data-cart-upsell-status]');
      if (status) status.textContent = quantity === 1 ? 'Article ajouté à votre panier.' : `${quantity} articles ajoutés à votre panier.`;
      if (continueButton) continueButton.disabled = false;
      if (!dialog.open) window.location.reload();
    })
    .catch(() => {
      addButton.disabled = false;
      addButton.textContent = originalText;
      if (continueButton) continueButton.disabled = false;
      const status = dialog.querySelector('[data-cart-upsell-status]');
      if (status) status.textContent = 'L’ajout a échoué. Réessayez dans un instant.';
    });
});

document.addEventListener('close', (event) => {
  const dialog = event.target;
  if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-cart-upsell-dialog]')) return;
  if (dialog.dataset.cartChanged === 'true' && dialog.dataset.continuing !== 'true') {
    window.location.reload();
  }
}, true);

document.addEventListener('click', (event) => {
  const continueButton = event.target.closest('[data-cart-upsell-continue]');
  if (continueButton) {
    const dialog = continueButton.closest('[data-cart-upsell-dialog]');
    if (dialog) dialog.dataset.continuing = 'true';
  }
});

document.addEventListener('click', (event) => {
  const dialog = event.target.closest?.('dialog[data-cart-upsell-dialog]');
  if (dialog && event.target === dialog) dialog.close();
});
